export default __webpack_public_path__ + "list-light.d9b977a3.svg";